import React from 'react';
import styles from './style.module.scss';

interface DividerLineProps {
  variant: 'dashed' | 'dotted' | 'solid';
  orientation: 'horizontal' | 'vertical';
  classNames?: string;
}

export const DividerLine = (props: DividerLineProps) => {
  const { variant, orientation, classNames } = props;

  const orientationClass = orientation === 'vertical' ? 'w-px h-32' : 'h-px w-full';

  const variantClass =
    variant === 'dashed'
      ? `border-transparent opacity-10 ${styles.dashedBorder}`
      : variant === 'dotted'
      ? 'border-dotted border-[1px] border-[#E9EBED]  '
      : 'border-solid border-[1px] border-[#E9EBED]  ';

  return (
    <div
      className={`${variantClass} ${orientationClass} ${classNames}`}
      data-testid={`${orientation}-${variant}-line`}
    ></div>
  );
};
